import { gradeGuideRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const gradeGuideRoute: RouteObject = {
  path: gradeGuideRoutePaths.gradeGuide.path,
  async lazy() {
    const GradeGuidePage = await import('@/pages/grade-guide/GradeGuidePage');
    return { Component: GradeGuidePage.default };
  },
};
